<script>
import api from '@/command/api'
import DetailFormGroup from '@/components/DetailFormGroup'
import { getAction, postAction, putAction } from '@/command/netTool'
import Naves from '@/views/com/Naves'
import Select from '@/components/FormView/FormSelect'
import { InputNumber, DatePicker } from 'ant-design-vue'
import moment from 'moment'
import {
  daysBeforeList,
  daysAfterList,
  timeAfterList,
  ticketRefundType,
  ticketRefundRatioList,
  hotelDaysAfterList,
  ticketRefundType1,
} from '@/utils/textFile'

export default {
  name: 'teamTicketDetail',
  data() {
    return {
      ...api.command.getState(),
      activeKey: 0,
      businessList: [],
      productList: [],
      detail: {
        attachmentButton: '0',
        productTeamDetailsList: [],
        productTeamDiscountRulesList: [],
        refundList: [],
        teamTicketSalePrice: null,
        minSellingQuantity: null,
        teamTicketSalePrice: null,
        preDay: 0,
        useAfterDay: 0,
        useAfterHour: 0,
        userInfoCount: 0,
        minSaleQuantity: null,
        refundExplain: '0',
        refundWay: '0',
        payType: '0',
        changeTicket: '0',
        qrShowMode: '0',
        changeTicket: '0',
        changeTicketAddress: '0',
        hxMode: '0',
        unSend: '0',
        realNameFlag: '1',
        sort: '0',
        hxAfterDay: 0,
        hxExpireType: '1',
        hxStartTime: '',
        hxEndTime: '',
        realNameInput: '',
      },
    }
  },
  watch: {},
  mounted() {
    this.getBusinessList()
    const { id } = this.$route.query
    if (id) {
      api.command.getDetail
        .call(this, {
          url: `/goods/farmProductTeamTicket/detail?id=${id}`,
        })
        .then((res) => {
          this.detail.productTeamDetailsList.forEach((item) => {
            this.storeSearchFarmProductCombo(item.businessId)
          })
          this.detail = {
            ...res,
            realNameInput: res.realNameInput ? res.realNameInput.split(',') : [],
            realNameFlag: !res.realNameFlag ? [] : ['0'].includes(res.realNameFlag) ? [] : res.realNameFlag.split(','),
            refundList: res.refundList || [],
          }
        })
    }
  },
  methods: {
    /** 数据查询 */
    getBusinessList() {
      getAction(`/api/farmTicketScenic/list`).then((result) => {
        this.businessList = result.data
          ? result.data.map((el) => {
              return {
                ...el,
                name: el.productName,
                value: el.id,
              }
            })
          : []
      })
    },
    async storeSearchFarmProductCombo(businessId) {
      if (!!this.productList.find((e) => e.businessId === businessId)) return
      const result = await api.command.search.call(this, {
        url: `/api/goods/farmProductCombo/getTicketProductList?businessId=${businessId}`,
      })
      this.productList = [
        ...this.productList,
        ...result.map((el) => ({
          ...el,
          name: el.productName,
          value: el.productId,
          businessId,
        })),
      ].filter((v, i, a) => a.findIndex((t) => t.value === v.value) === i)
    },

    onTimeChange(times) {
      if (times.length > 0) {
        this.detail.hxStartTime = moment(times[0]).format('YYYY-MM-DD 00:00:00')
        this.detail.hxEndTime = moment(times[1]).format('YYYY-MM-DD 00:00:00')
      }
    },
    getData() {
      return [this.detail.hxStartTime, this.detail.hxEndTime]
    },
    /** end 数据查询 */

    getForm1() {
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '团队票名称（40字符）',
            type: 'input',
            cols: 12,
            key: 'teamTicketName',
            props: {
              maxLength: 40,
            },
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '排序',
            type: 'inputNumber',
            cols: 12,
            key: 'sort',
            maxLength: 35,
          },
        ],
      }
    },
    getFormUp() {
      return {
        type: 'tabs',
        key: 'selectType',
        children: [
          {
            title: () => (
              <div>
                <span style="color:#f00">*</span>
                Banner(限制10张)
              </div>
            ),
            data: [
              {
                type: 'iconUpload',
                maxLength: 1,
                cols: 12,
                descTitle: 'Banner',
                key: 'bannerUrl',
                typeData: [
                  {
                    maxLength: 10,
                    key: 'bannerUrl',
                  },
                ],
                rules: [
                  {
                    required: true,
                    message: '请上传图片',
                    type: 'string',
                  },
                ],
              },
            ],
          },
          {
            title: '宣传视频',
            data: [
              {
                type: 'iconUploadVideo',
                cols: 12,
                descTitle: '宣传视频',
                typeData: [
                  {
                    maxLength: 1,
                    key: 'videoUrl',
                    desc: '视频上传尺寸<20M <br /> 支持格式.mov/.mp4/.wmv/.avi',
                  },
                ],
              },
            ],
          },
        ],
      }
    },
    getAttachment() {
      return {
        title: '游客名单上传（支持格式图片、PDF、Excel）',
        type: 'cardForm',
        data: [
          {
            name: '是否要上传游客名单',
            type: 'switch',
            cols: 24,
            key: 'attachmentButton',
            reversal: true,
            onChange: (state) => {
              this.detail.attachmentButton = state ? '1' : '0'
            },
          },
        ],
      }
    },
    //#endregion 基础设置

    getAddGoods() {
      let that = this
      return {
        title: '添加商品',
        type: 'cardForm',
        data: [
          {
            cols: 24,
            type: 'table',
            showRowSelect: false,
            showPagination: false,
            showFootButton: true,
            columns: [
              {
                dataIndex: 'businessId',
                align: 'left',
                title: '景点名称',
                type: 'select',
                width: 230,
                customRender: (text, records, index) => {
                  return (
                    <Select
                      item={{
                        name: '景点名称',
                        onChange: (data) => {
                          this.detail.productTeamDetailsList[index].productId = ''
                          this.detail.productTeamDetailsList[index].productName = ''
                          this.detail.productTeamDetailsList[index].businessId = data
                          this.detail.productTeamDetailsList[index].businessName = this.businessList.filter(
                            (e) => e.value == data
                          )[0].name
                          this.detail.productTeamDetailsList[index].linkShopId = this.businessList.filter(
                            (e) => e.value == data
                          )[0].linkShopId
                          if (data) {
                            this.storeSearchFarmProductCombo(data)
                          }
                          this.$forceUpdate()
                        },
                      }}
                      value={this.detail.productTeamDetailsList[index].businessId}
                      typeData={this.businessList}
                    />
                  )
                },
              },
              {
                dataIndex: 'productId',
                align: 'left',
                title: '商品名称',
                type: 'select',
                width: 230,
                customRender: (text, records, index) => {
                  return (
                    <Select
                      item={{
                        name: '商品名称',
                        disabled: !this.detail.productTeamDetailsList[index].businessId,
                        onChange: (data) => {
                          this.detail.productTeamDetailsList[index].productId = data
                          this.detail.productTeamDetailsList[index].productName = this.productList.filter(
                            (e) => e.value == data
                          )[0].name
                          this.$forceUpdate()
                        },
                      }}
                      typeData={this.productList.filter(
                        (e) => e.businessId == this.detail.productTeamDetailsList[index].businessId
                      )}
                      value={this.detail.productTeamDetailsList[index].productId}
                    />
                  )
                },
              },
              {
                dataIndex: 'a10',
                align: 'center',
                width: 60,
                title: '操作',
                type: 'buttonGroup',
                typeData: ({ records, item, index }) => {
                  return [
                    {
                      name: '删除',
                      popTitle: '确认是否删除吗?',
                      onClick: () => {
                        this.detail.productTeamDetailsList.splice(index, 1)
                      },
                    },
                  ]
                },
              },
            ],
            dataSource: this.detail.productTeamDetailsList,
          },
        ],
      }
    },

    // 销售设置
    getFormXssz() {
      return {
        title: '销售设置',
        type: 'cardForm',
        data: [
          {
            display: true,
            name: '支付方式',
            type: 'radioButton',
            key: 'payType',
            cols: 6,
            typeData: [
              {
                name: '在线支付',
                value: '0',
              },
            ],
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            display: true,
            name: '门票选择数量',
            type: 'inputNumber',
            key: 'minSellingQuantity',
            cols: 6,
            props: {
              min: 1,
            },
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
          },
          {
            display: true,
            name: '门票起卖数量',
            type: 'inputNumber',
            key: 'minSaleQuantity',
            cols: 6,
            props: {
              min: 1,
            },
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
          },
          {
            display: true,
            name: '票起始价格',
            type: 'inputNumber',
            key: 'teamTicketSalePrice',
            cols: 6,
            props: {
              min: 0,
            },
            props: {
              addonAfter: '元',
            },
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
          },
          {
            name: '使用日期(新的设置适用于新产生的订单；对于已经产生的订单，仍需按原有的核销时间为用户提供服务)',
            type: 'radio',
            key: 'hxExpireType',
            cols: 12,
            display: true,
            typeData: [
              {
                name: () => {
                  const onInput = (data) => {
                    this.detail.hxAfterDay = data.target.value
                  }
                  return (
                    <span style="margin-right: 100px">
                      必须在购买后&nbsp;
                      <a-input
                        style={{ width: '70px' }}
                        type="number"
                        min={0}
                        placeholder=""
                        onChange={onInput}
                        value={this.detail.hxAfterDay}
                      />
                      &nbsp;天内使用
                    </span>
                  )
                },
                value: '1',
              },
              {
                name: () => {
                  return <span style="margin-right: 100px">在指定购买日期使用</span>
                },
                value: '0',
              },
              {
                style: {
                  marginTop: '10px',
                },
                name: () => {
                  return (
                    <span style={{ marginTop: '30px' }}>
                      在购买后&nbsp;
                      <DatePicker.RangePicker
                        showTime={false}
                        ranges={{
                          最近一周: [moment(), moment().add(1, 'weeks')],
                          最近一个月: [moment(), moment().add(1, 'month')],
                          最近三个月: [moment(), moment().add(3, 'month')],
                        }}
                        allowClear={false}
                        onChange={this.onTimeChange}
                        value={this.getData()}
                        style={{ width: '400px' }}
                        format="YYYY-MM-DD"
                        placeholder={['开始日期', '结束日期']}
                      ></DatePicker.RangePicker>
                      &nbsp;时间段内都可使用
                    </span>
                  )
                },
                value: '5',
              },
            ],
          },
        ],
      }
    },
    getFormGmxz() {
      return {
        title: '预定设置',
        type: 'cardForm',
        data: [
          {
            display: true,
            name: '最大可预定天数',
            type: 'row',
            cols: 12,
            gutter: 6,
            children: [
              {
                type: 'text',
                value: '在开售时间起提前',
                cols: 4,
              },
              {
                label: '',
                type: 'inputNumber',
                key: 'preDay',
                cols: 3,
                props: {
                  min: 0,
                },
              },
              {
                type: 'text',
                value: '天可提前预定',
                cols: 4,
              },
            ],
          },
          {
            display: true,
            name: '生效时间限制',
            type: 'row',
            cols: 12,
            gutter: 6,
            children: [
              {
                type: 'text',
                value: '必须在购买后',
                cols: 3,
              },
              {
                label: '',
                type: 'inputNumber',
                key: 'useAfterDay',
                cols: 3,
                props: {
                  min: 0,
                },
              },
              {
                type: 'text',
                value: '天，',
                cols: 1,
              },
              {
                label: '',
                type: 'inputNumber',
                key: 'useAfterHour',
                cols: 3,
                props: {
                  min: 0,
                  max: 23,
                },
              },
              {
                type: 'text',
                value: '小时，才可使用',
                cols: 4,
              },
            ],
          },
          {
            display: true,
            name: '用户信息',
            type: 'checkBoxButton',
            key: 'realNameFlag',
            cols: 12,
            typeData: [
              {
                name: '实名制',
                value: '1',
              },
            ],
          },
          {
            display: this.detail.realNameFlag?.length > 0,
            name: '下单时填写信息',
            type: 'checkBoxButton',
            key: 'realNameInput',
            cols: 12,
            typeData: [
              {
                name: '姓名',
                value: 'link_man',
              },
              {
                name: '电话',
                value: 'link_phone',
              },
              {
                name: '身份证',
                value: 'link_credit_no',
              },
            ],
            rules: [
              {
                required: true,
                type: 'array',
                message: '请最少选择一种',
              },
            ],
          },
          {
            display: true,
            name: '用户信息数量',
            type: 'radioButton',
            key: 'userInfoCount',
            cols: 12,
            typeData: [
              {
                name: '只填写一个人信息',
                value: 0,
              },
              {
                name: '根据下单数量填写所有用户信息',
                value: 1,
              },
            ],
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
          },
          {
            display: true,
            name: '预定成功发送',
            type: 'radioButton',
            key: 'unSend',
            cols: 12,
            typeData: [
              {
                name: '不发送',
                value: '0',
              },
              {
                name: '发送短信',
                value: '1',
              },
            ],
          },
          {
            display: true,
            name: '预定说明',
            type: 'textArea',
            key: 'predetermineNote',
            cols: 24,
            maxLength: 200,
            minHeight: '80px',
            showCount: true,
          },
        ].filter((e) => e.display),
      }
    },

    getDiscountRules() {
      return {
        title: '折扣规则',
        type: 'cardForm',
        data: [
          {
            cols: 24,
            type: 'table',
            showRowSelect: false,
            showPagination: false,
            showFootButton: true,
            columns: [
              {
                dataIndex: 'productQuantity',
                align: 'left',
                title: '门票数量',
                type: 'select',
                width: 230,
                customRender: (text, records) => {
                  const onInput = (value) => {
                    records.productQuantity = value
                    console.log(this.detail, '22')
                  }
                  return (
                    <InputNumber
                      placeholder="请输入"
                      min={0}
                      precision={0}
                      onChange={onInput}
                      defaultValue={text}
                      style={'width:100%'}
                    />
                  )
                },
              },
              {
                dataIndex: 'productDiscount',
                align: 'left',
                title: '折扣',
                type: 'select',
                width: 230,
                customRender: (text, records) => {
                  const onInput = (data) => {
                    records.productDiscount = data.target.value
                  }
                  return <a-input type="number" placeholder="请输入" onChange={onInput} value={text} addonAfter="折" />
                },
              },
              {
                dataIndex: 'a10',
                align: 'center',
                width: 60,
                title: '操作',
                type: 'buttonGroup',
                typeData: ({ records, item, index }) => {
                  return [
                    {
                      name: '删除',
                      popTitle: '确认是否删除吗?',
                      onClick: () => {
                        this.detail.productTeamDiscountRulesList.splice(index, 1)
                      },
                    },
                  ]
                },
              },
            ],
            dataSource: this.detail.productTeamDiscountRulesList,
          },
        ],
      }
    },
    getFormTksz() {
      return {
        title: '退款设置',
        type: 'cardForm',
        data: [
          {
            display: true,
            name: '退款方式',
            type: 'radioButton',
            key: 'refundExplain',
            cols: 12,
            typeData: [
              {
                name: '随时退',
                value: '0',
              },
              {
                name: '不支持退款',
                value: '1',
              },
              {
                name: '有效期内随时可退',
                value: '2',
              },
            ],
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            display: true,
            name: '自定义协议',
            type: 'textArea',
            cols: 12,
            key: 'refundAgreement',
            maxLength: 1000,
            minHeight: '100px',
            showCount: true,
          },
        ].filter((e) => e.display),
      }
    },
    getFormRules() {
      let that = this
      return {
        title: '退款规则',
        type: 'cardForm',
        data: [
          {
            display: this.detail.refundExplain == '0',
            type: 'radioButton',
            key: 'refundWay',
            style: {
              paddingLeft: '20px',
            },
            cols: 24,
            typeData: [
              {
                name: '手动退',
                value: '0',
              },
              {
                name: '过期自动退',
                value: '1',
              },
            ],
          },
          {
            display:
              that.detail.refundExplain == '2' || (that.detail.refundExplain == '0' && that.detail.refundWay == '0'),
            cols: 24,
            type: 'table',
            showFootButton: true,
            showRowSelect: false,
            showPagination: false,
            // table新增按钮回调
            onAddData: () => {
              return {
                validDay: '1',
                validDate: '6',
                refundType: '0',
                refundExplain: 0,
              }
            },
            columns: [
              {
                dataIndex: 'validDay',
                align: 'left',
                width: '22%',
                title: (
                  <div>
                    <span style="color:#f5222d">*</span>有效日期
                  </div>
                ),
                customRender: function (text, records, index) {
                  const onChange = (data) => {
                    records.validDay = data
                  }
                  return (
                    <a-select onChange={onChange} style={{ width: '100%' }} placeholder="有效日期" defaultValue={text}>
                      {that.detail.refundExplain == '0' &&
                        daysBeforeList.map((e) => {
                          return <a-select-option value={e.value}>{e.name}</a-select-option>
                        })}
                      {that.detail.refundExplain !== '0' &&
                        daysAfterList.map((e) => {
                          return <a-select-option value={e.value}>{e.name}</a-select-option>
                        })}
                    </a-select>
                  )
                },
              },
              {
                dataIndex: 'validDate',
                align: 'left',
                width: '22%',
                title: (
                  <div>
                    <span style="color:#f5222d">*</span>有效时间
                  </div>
                ),
                customRender: function (text, records, index) {
                  const onChange = (data) => {
                    records.validDate = data
                  }
                  return (
                    <a-select onChange={onChange} style={{ width: '100%' }} placeholder="有效时间" defaultValue={text}>
                      {timeAfterList.map((e) => {
                        return <a-select-option value={e.value}>{e.name}</a-select-option>
                      })}
                    </a-select>
                  )
                },
              },
              {
                dataIndex: 'refundType',
                align: 'left',
                title: (
                  <div>
                    <span style="color:#f5222d">*</span>退款类别
                  </div>
                ),
                width: '22%',
                customRender: function (text, records, index) {
                  const onChange = (data) => {
                    records.refundType = data
                    records.refundExplain = 0
                    that.$forceUpdate()
                  }
                  return (
                    <a-select onChange={onChange} style={{ width: '100%' }} placeholder="退款类别" defaultValue={text}>
                      {ticketRefundType.map((e) => {
                        return <a-select-option value={e.value}>{e.name}</a-select-option>
                      })}
                    </a-select>
                  )
                },
              },
              {
                dataIndex: 'refundExplain',
                align: 'left',
                width: '22%',
                title: (
                  <div>
                    <span style="color:#f5222d">*</span>扣款金额/系数
                  </div>
                ),
                customRender: function (text, records, index) {
                  const onInput = (data) => {
                    records.refundExplain = data.target.value && Number(data.target.value)
                  }
                  const onChange = (data) => {
                    records.refundExplain = data

                    that.$forceUpdate()
                  }
                  if (records.refundType == '1') {
                    return (
                      <a-select
                        onChange={onChange}
                        style={{ width: '100%' }}
                        placeholder="扣款金额/系数"
                        defaultValue={text}
                      >
                        {ticketRefundRatioList.map((e) => {
                          return <a-select-option value={e.value}>{e.name}</a-select-option>
                        })}
                      </a-select>
                    )
                  }
                  return <a-input type="number" placeholder="扣款金额/系数" onChange={onInput} value={text} />
                },
              },
              {
                dataIndex: 'a10',
                align: 'center',
                width: '12%',
                title: '操作',
                unShowEditBtn: true,
                tableType: 'editDelete',
                onDel: (text, records, index) => {
                  if (that.detail.refundList.length > 1) {
                    that.detail.refundList.splice(index, 1)
                  } else {
                    this.$message.error('退款规则最少保留一条规则！')
                  }
                },
              },
            ],
            dataSource: that.detail.refundList,
          },
        ].filter((e) => e.display),
      }
    },
    getFormUse() {
      return {
        title: '使用说明',
        type: 'cardForm',
        data: [
          {
            display: true,
            name: '核销模式',
            type: 'radioButton',
            key: 'hxMode',
            cols: 12,
            onChange: (value) => {
              if (value == '1') {
                this.detail.qrShowMode = '0'
              }
            },
            typeData: [
              {
                name: '1码1人',
                value: '0',
              },
              {
                name: '1码多人',
                value: '1',
              },
            ],
          },
          {
            display: true,
            name: '门票码展示',
            type: 'radioButton',
            key: 'qrShowMode',
            cols: 12,
            disabled: this.detail.hxMode == '1',
            typeData: [
              {
                name: '单码',
                value: '0',
              },
              {
                name: '多码',
                value: '1',
              },
            ],
          },
          {
            display: true,
            name: '入园设置',
            type: 'radioButton',
            key: 'changeTicket',
            cols: 12,
            typeData: [
              {
                name: '无需换票',
                value: '0',
              },
              {
                name: '换票使用',
                value: '1',
              },
            ],
          },
          {
            display: this.detail.changeTicket == 1,
            name: '换票地址',
            type: 'input',
            key: 'changeTicketAddress',
            cols: 12,
          },
          {
            display: true,
            name: '说明',
            type: 'textArea',
            key: 'changeTicketRemark',
            cols: 12,
            maxLength: 1000,
            minHeight: '100px',
            showCount: true,
          },
        ].filter((e) => e.display),
      }
    },
    getFormDescriptionFees() {
      return {
        title: '费用说明',
        type: 'cardForm',
        data: [
          {
            type: 'input',
            name: '费用包含',
            cols: 24,
            key: 'expenseContain',
            maxLength: 200,
          },
        ],
      }
    },
    getFormTk() {
      return {
        title: '订单退款确认方式',
        type: 'cardForm',
        data: [
          {
            display: true,
            name: '退款确认方式',
            type: 'radioButton',
            key: 'refundType',
            cols: 12,
            typeData: [
              {
                name: '人工审核退款',
                value: '0',
              },
              {
                name: '自动处理退款',
                value: '1',
              },
            ],
            rules: [
              {
                required: true,
              },
            ],
          },
        ].filter((e) => e.display),
      }
    },
    getFoot() {
      const left = [
        {
          name: '上一步',
          display: this.activeKey > 0,
          onClick: () => (this.activeKey = this.activeKey - 1),
        },
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          display: true,
          onClick: (data) => {
            let upDown = data.id ? data.upDown : '0'
            if (this.detail.hxExpireType == '1') {
              if (!this.detail.hxAfterDay) {
                this.$message.warning('销售设置，使用日期必填')
                return false
              }
            }
            if (this.detail.hxExpireType == '5') {
              if (this.detail.hxStartTime && this.detail.hxEndTime) {
                if (!moment(this.detail.hxStartTime).isBefore(this.detail.hxEndTime)) {
                  this.$message.warning('日期开始时间不能小于日期结束时间!')
                  return false
                }
              } else {
                this.$message.warning('销售设置，使用日期必填')
                return false
              }
            }

            if (!data.refundExplain && this.detail.preSellFlag === '1') {
              this.$message.warning('请选择退款设置！')
              return
            }
            if (
              data.refundExplain == 2 &&
              (this.detail?.refundList || []).length < 1 &&
              this.detail.preSellFlag === '1'
            ) {
              this.$message.warning('退款规则最少保留一条规则！')
              return
            }
            let newrefundList = this.detail?.refundList.map((e) => {
              return {
                ...e,
                validDayName:
                  this.detail.refundExplain == '0'
                    ? daysBeforeList.find(({ value }) => value === e.validDay).name
                    : daysAfterList.find(({ value }) => value === e.validDay).name,
                validDateName: timeAfterList.find(({ value }) => value === e.validDate).name,
                refundExplain: e.refundExplain ? e.refundExplain : 0,
              }
            })
            let obj = Object.assign({
              ...data,
              upDown,
              realNameFlag: (data.realNameFlag || []).toString(),
              realNameInput: data.realNameInput && data.realNameInput.length > 0 ? data.realNameInput.join(',') : '',
              refundList: newrefundList,
            })
            api.command[data.id ? 'edit' : 'create']
              .call(this, {
                url: data.id ? '/goods/farmProductTeamTicket/update' : `/goods/farmProductTeamTicket/save`,
                params: obj,
                isPost: false,
              })
              .then((result) => {
                setTimeout(() => {
                  this.$router.back()
                }, 500)
              })
          },
        },
        {
          name: '下一步',
          display: this.activeKey != 3,
          onClick: (data) => {
            this.activeKey = this.activeKey + 1
          },
        },
      ].filter((e) => e.display)
      const right = [
        {
          name: '取消',
          type: 'default',
          onClick: () => this.$router.back(),
          display: true,
        },
        {
          name: ` ${this.detail.upDown == 0 ? '下架' : '上架'} `,
          type: 'default',
          onClick: () => {
            getAction(
              `/goods/farmProductTeamTicket/${this.detail.upDown == 0 ? 'down' : 'up'}?id=${this.detail.id}`
            ).then((e) => {
              if (e.code == 200) {
                this.$message.success(`${this.detail.upDown == 0 ? '下架成功' : '上架成功'}`)
                setTimeout(() => {
                  this.$router.back()
                }, 500)
              } else {
                this.$message.error(e.msg)
              }
            })
          },
          display: this.detail.id,
        },
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.del.call(this, {
              url: `/goods/farmProductTeamTicket?id=${this.detail.id}`,
              isPost: false,
            })

            setTimeout(() => {
              this.$router.back()
            }, 500)
          },
          display: this.detail.id,
        },
      ].filter((e) => e.display)
      return {
        left,
        right,
      }
    },
    renderTab() {
      if (this.activeKey === 0) {
        return [this.getForm1(), this.getAddGoods(), this.getFormUp(), this.getAttachment()]
      } else if (this.activeKey === 1) {
        return [this.getFormXssz(), this.getFormGmxz()]
      } else if (this.activeKey === 2) {
        return [this.getDiscountRules()]
      } else if (this.activeKey === 3) {
        return [
          this.getFormTksz(),
          this.detail.refundExplain !== '1' && this.getFormRules(),
          this.getFormUse(),
          this.getFormDescriptionFees(),
          this.getFormTk(),
        ]
      }
    },
  },
  render() {
    return (
      <div>
        <Naves
          navData={['基础设置', '销售设置', '规则设置', '退款设置']}
          onActive={(index) => {
            this.activeKey = index
          }}
          activeCurrentKey={this.activeKey}
        />
        <DetailFormGroup foot={this.getFoot()} form={this.detail} typeData={{}} data={this.renderTab()} />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
/deep/ .detail-form-group {
  height: calc(100vh - 230px);
}

.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}

/deep/.ant-input[type='number'] {
  -moz-appearance: textfield;
}
/deep/.ant-input[type='number']::-webkit-inner-spin-button,
/deep/.ant-input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.boxes {
  .data-list-box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  &-two {
    height: 82px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    border-top: 1px solid #e8eaec;
    padding-top: 15px;
    box-sizing: border-box;

    input {
      width: 40%;
    }
  }
  &-one {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 100px;
    padding-top: 15px;
    padding-bottom: 15px;

    &:nth-of-type(2) {
      border-top: 1px solid #e8eaec;
      box-sizing: border-box;
    }

    .con {
      width: 58%;
    }

    &-checkbox {
      width: 40%;

      & > :nth-child(1) {
        border: 1px solid #e8eaec;
        padding: 5px 10px;
        box-sizing: border-box;
      }
    }
  }
}
.add_commodity {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
}
</style>
